import React from 'react';
import {
    Datagrid,
    DateField,
    DateInput,
    DeleteButton,
    EditButton,
    Filter,
    List,
    ReferenceField,
    ShowButton,
    TextField
} from 'react-admin';
import {CancelRequestStatusField, CancelRequestStatusInput} from "./CancelRequestStatus";

const canEdit = (status) => ["DRAFT"].includes((status || "").toUpperCase());
const canDelete = (status) => ["DRAFT"].includes((status || "").toUpperCase());

const RowActions = ({record, basePath, ...props}) => (
    <div style={{display: "flex", gap: 8}}>
        <ShowButton {...props} basePath={basePath} record={record}/>
        {record && canEdit(record.status) && <EditButton basePath={basePath} record={record} {...props} />}
        {record && canDelete(record.status) && <DeleteButton basePath={basePath} record={record} {...props} />}
    </div>
);

const PurchaseCancelRequestFilter = (props) => (
    <Filter {...props}>
        <DateInput source="fromDate" alwaysOn/>
        <DateInput source="toDate" alwaysOn/>
        <CancelRequestStatusInput source="status" alwaysOn/>
    </Filter>
);
export const PurchaseCancelRequestList = props => (
    <List filters={<PurchaseCancelRequestFilter/>} {...props} perPage={25} exporter={false} bulkActionButtons={false}>
        <Datagrid rowClick={false}>
            <TextField source="cancelFromDate"/>
            <TextField source="cancelToDate"/>
            <ReferenceField source="kiotConfigId" reference="kiotConfigs">
                <TextField source="name"/>
            </ReferenceField>
            <DateField source="requestTime" showTime/>
            <DateField source="authorizedTime" showTime/>
            <CancelRequestStatusField source="status"/>
            <RowActions/>
        </Datagrid>
    </List>
);

export default PurchaseCancelRequestList
